/** Save and Cancel for the set-rate form. */
export default function SetRateActions({
  canSave,
  busy,
  onCancel,
}: {
  canSave: boolean;
  busy: boolean;
  onCancel: () => void;
}) {
  return (
    <div className="flex items-center gap-2">
      <button
        type="submit"
        disabled={!canSave}
        className="min-h-[28px] rounded bg-moss-600 px-3 py-1 text-sm text-white hover:bg-moss-700 disabled:opacity-50"
      >
        {busy ? 'Saving…' : 'Save'}
      </button>
      <button
        type="button"
        onClick={onCancel}
        className="min-h-[28px] px-2 text-sm text-stone-600 hover:text-stone-800 dark:text-stone-400 dark:hover:text-stone-200"
      >
        Cancel
      </button>
    </div>
  );
}
